document.addEventListener("DOMContentLoaded", function () {
  const moreDetails = document.getElementById("more-details");
  const toggleLink = document.querySelector("#checkbox-container a");

  if (moreDetails && toggleLink) {
    const toggleText = toggleLink.querySelector("span");

    toggleLink.addEventListener("click", function (event) {
      event.preventDefault();

      const isHidden =
        moreDetails.style.display === "none" ||
        moreDetails.style.display === "";

      moreDetails.style.display = isHidden ? "block" : "none";
      toggleText.textContent = isHidden
        ? "See less product details ↑"
        : "See more product details ↓";
    });
  }
});

